import { useMutation } from '@tanstack/react-query';
import {
	ICapacityDashboard,
	ICapacityDashboardParams,
} from 'models/capacity/capacityDashboard.model';
import api from 'services/api/api';

export const getCapacityDashboard = async (
	params: ICapacityDashboardParams
): Promise<ICapacityDashboard | null> => {
	const { recursos, meses, ...rest } = params;
	if (!rest.ciclo_id) {
		return null;
	}
	const resourceQuery = recursos
		.map(resource => `recursos=${resource.value}`)
		.join('&');
	const monthQuery = meses.map(month => `meses=${month.value}`).join('&');

	const query = [] as string[];

	if (resourceQuery) query.push(resourceQuery);
	if (monthQuery) query.push(monthQuery);

	const response = await api.get(`/dashboardCapacidade?${query.join('&')}`, {
		params: {
			...rest,
		},
	});
	return response.data;
};

export const useCapacityDashboard = (params: ICapacityDashboardParams) => {
	return useMutation(() => getCapacityDashboard(params));
};
